import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import AccountForm from '../../types/account-form.types'
import { Lang } from '../../types/common-types'
import { State, profileType_Fiscal } from '../../state-actions-reducers'
import styles from './ConfirmRemember.module.scss'
import GreenCheckMarkImage from '../../images/greencheckmark.svg'
import Button from '../../shared/Buttons/Button'
import CatImg from '../../images/cat.webp'

interface Props {
  lang: Lang
  onAccept: () => void
  accountForm: AccountForm
}

export default function ConfirmRemember({
  lang,
  onAccept,
  accountForm,
}: Props) {
  const { watch } = useFormContext<State>()
  const state = watch()

  useEffect(() => {
    // Reset state user closes tab
    window.addEventListener('unload', onAccept)
    return () => {
      window.removeEventListener('unload', onAccept)
    }
  })

  return (
    <>
      <main className={styles.ConfirmRemember}>
        <div className="row">
          <div className="col-12">
            <div className={styles.ConfirmRemember__imageBox}>
              <img src={CatImg} alt="success" />
            </div>
            <h2 className={styles.ConfirmRemember__h2}>
              {accountForm.successSubmit.head[lang]}
            </h2>
            <h3 className={styles.ConfirmRemember__h3}>
              {accountForm.successSubmit.header[lang]}
            </h3>
            {lang === 'rus' ? <p className={styles.ConfirmRemember__text}>
              Обычно проверка анкеты занимает {' '}
              <span>пару часов</span>
              , в редких случаях {' '}
              <span>до 2 дней. Но мы всегда стараемся сделать быстрее!</span>
              <br />
              После рассмотрения заявки менеджер свяжется с вами и сообщит о решении и условиях гарантии.
            </p> : <p className={styles.ConfirmRemember__text}>
              Usually, it takes a {' '}
              <span>couple of hours</span> to check the questionnaire
              ; in rare cases, it can take up to {' '}
              <span>2 days. But we always try to make it faster!</span>
              <br />
              After considering the application, the manager will contact you and inform you about the decision and collateral conditions.
            </p>}
            {state.profileType !== profileType_Fiscal ? lang === 'rus' ? <p className={styles.ConfirmRemember__text}>
              На указанную почту Вам отправлено письмо.<br/>
              Через несколько минут оно будет у Вас!<br/>
              По логину и паролю из письма можно зайти в Личный Кабинет.<br/>
              Теперь в Киноаренду, как к себе домой!
            </p> : <p className={styles.ConfirmRemember__text}>
              We sent you a letter by email.<br/>
              In a few minutes the email will be with you!<br/>
              You can get access to your Personal Account using this login and password.<br/>
              Feel at home in Kinoarenda now!
            </p> : null}
            <div className={styles.buttonBox}>
              <Button
                bg={'accent'}
                value={accountForm.gotoMainPage[lang]}
                onClick={() => {
                  if (window.parentIFrame) window.parentIFrame.sendMessage({
                    clickGoHome: true
                  })
                  window.location.reload()
                }}
              />
            </div>
          </div>
          {/* <div className={styles.accauntDescContainer + ' ' + 'col-12'}>
            <div className={styles.accauntDescBox + ' ' + 'col-5'}>
              <img src={CartImage} alt="cart" />
              <span>Для продолжения формирования<br/> заказа перейдите в личный кабинет.<br/> Первый вход будет выполнен через смс.</span>
            </div>
            <div className={styles.accauntDescBox + ' ' + 'col-5'}>
              <img src={MailImage} alt="mail" />
              <span>На почту придет ссылка на личный<br/> кабинет, в котором можно оследить<br/> статус рассмотрения анкеты. </span>
            </div>
          </div> */}
        </div>
      </main>
    </>
  )
}
